import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { tableAdvKeywords } from '../../helper';
import {
    getAdvKeywordsData,
    handleLoader
}
    from '../../../../redux/actions/AdvKeywordsAction';
import AdvKeywordsTable from './AdvKeywordsTable';

const AdvKeywords = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const { advKeywordsData, salesChannelFilterData, isLoading } = useSelector(
        ({ advKeywordsReducer, marketPlaceReducer }) =>
        ({
            advKeywordsData: advKeywordsReducer.advKeywordsData,
            isLoading: advKeywordsReducer.isLoading,
            salesChannelFilterData: marketPlaceReducer.salesChannel,

        })
    );

    const previousMonthDate = new Date();
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

    const [advProductsDataToShow, setDataToShow] = useState([])
    const [filterData, setFilterData] = useState({});
    const [selectedCountryOptions, setSelectedCountryOptions] = useState({ value: 'US', label: 'USA' });
    const [fromDate, setFromDate] = useState(previousMonthDate);
    const [toDate, setToDate] = useState(new Date());

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Advertising Keywords Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    const countryCodeOptions = [];
    const callApi = () => {
        dispatch(handleLoader(true));
        dispatch(getAdvKeywordsData(
            {
                country: selectedCountryOptions?.value,
                fromdate: moment(fromDate).format('YYYY-MM-DD'),
                todate: moment(toDate).format('YYYY-MM-DD')
            }
        ));
    }

    const handleApplyDate = () => {
        const intFromDate = moment(fromDate).format('YYYYMMDD');
        const intToDate = moment(toDate).format('YYYYMMDD');
        if (intToDate > intFromDate) {
            callApi()
        }
        else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'To Date must be greater than From Date.'
                });
            });
        }
    }
    // eslint-disable-next-line array-callback-return
    advKeywordsData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
        data.filterData.forEach((element) => {
            countryCodeOptions.push({
                value: element.key,
                label: element.shortValue
            });
        });
    });

    const sortedCountryOptions = countryCodeOptions.sort((a, b) => a.label > b.label ? 1 : -1)
    // eslint-disable-next-line react/prop-types
    const changeFilterForCountry = (value) => {
        setSelectedCountryOptions(value)
    };

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setDataToShow(advKeywordsData?.modal?.data || []);
    }, [advKeywordsData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])


    const dataToShowForDatesSelected = advProductsDataToShow?.filter(item => filterBasedOnFilter(item))

    return (
        <Container className="dashboard">
            <Row className="category-sales">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">Advertising Keywords</h5>
                            </div>
                            <Row className="align-items-center">
                                <Col sm="3" md="2">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Country</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={selectedCountryOptions}
                                                options={sortedCountryOptions}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter"
                                                onChange={changeFilterForCountry}
                                                classNamePrefix="react-select"
                                            // isMulti
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col sm="3" md="10">
                                    <Row className="align-items-center">
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(fromDate).toDate()}
                                                            showPreviousMonths
                                                            onChange={handleFromDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="3">
                                            <div className="form__form-group mb-0">
                                                <span className="form__form-group-label">To Date</span>
                                                <div className="form__form-group-field">
                                                    <div className="date-picker">
                                                        <DatePicker
                                                            className="form__form-group-datepicker"
                                                            selected={moment(toDate).toDate()}
                                                            onChange={handleToDateChange}
                                                            dateFormat="MM/dd/yyyy"
                                                            dropDownMode="select"
                                                            popperPlacement="center"
                                                            withPortal={isMobileOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="6" style={{ top: '10px' }}>
                                            <button className="btn btn-sm btn-primary apply-date-button"
                                                type="button" onClick={handleApplyDate}>
                                                Apply</button>
                                                <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                        </Col>                                        
                                    </Row>
                                </Col>

                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                        style={{ minHeight: '400' }}>
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <AdvKeywordsTable
                                    data={dataToShowForDatesSelected}
                                    tableHeaderData={tableAdvKeywords}
                                />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            </div>
        </Container>
    );
};

AdvKeywords.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
}

export default connect(state => ({
    rtl: state.rtl,
}))(AdvKeywords)